module.exports = __webpack_public_path__ + "img/toyota-new.723e7d4d.png";